module.exports = __webpack_public_path__ + "static/media/prod_30000_small.c23327f1.jpg";